import { getPostMediaTypes } from '../../application/pageDataObject'
import { classList } from '../../utils/dom'
import { warn } from '../../application/console'

function getTemplateClassName(mediaType) {
  return `media-type--${mediaType}`
}

export default function initPageTemplateClassifier() {
  const classNames = getPostMediaTypes().map(getTemplateClassName)
  if (!classNames.length) {
    warn('This page has no templates', { mediaTypes: getPostMediaTypes(), classNames })
    return
  }
  classList(document.body).add(...classNames)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/pageTemplateClassifier.js